import React, { useState, Fragment } from 'react';
import {
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import stripe_logo from "../../../../../assets/stripe_logo.jpg";
export default function ShowMessage({
    formbody,
    visible,
    toggle,
    logo
}) {
    return (
        <Fragment>
            <Modal
                isOpen={visible}
                toggle={toggle}
                size="lg"
                style={{ maxwidth: "40%" }}
            >
                <ModalHeader toggle={toggle}> <Row>
                    <div className="col-md-12" style={{ padding: "4%" }}>
                        <img
                            src={logo}
                            style={{ height: "50px" }} />
                        <br />
                    </div>
                </Row></ModalHeader>
                <ModalBody>
                    <Row>
                        <div className="col-md-12" style={{ padding: "4%", maxWidth: "100%" }}>
                            <h1 style={{ margin: "1%" }}>{formbody}</h1>
                        </div>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}